import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InboundIpAddresses from '../../_snippets/inbound-ip-addresses.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Azure SQL Server connector can link your database tables to PostHog.`}</p>
    <blockquote>
      <p parentName="blockquote">{`This applies to any MS SQL Server, not just Azure hosted databases. We use Microsoft ODBC 18 to connect to your SQL server.`}</p>
    </blockquote>
    <p>{`For Azure databases, we only use SQL authentication (and not Entra ID). You can find your connection details by `}<a parentName="p" {...{
        "href": "https://learn.microsoft.com/en-us/azure/azure-sql/database/connect-query-content-reference-guide?view=azuresql#get-adonet-connection-information-optional---sql-database-only"
      }}>{`following the steps listed here`}</a>{`.`}</p>
    <p>{`The Azure database also needs to be publicly accessible (or use a SSH tunnel). You can follow `}<a parentName="p" {...{
        "href": "https://learn.microsoft.com/en-us/azure/azure-sql/database/azure-sql-python-quickstart?view=azuresql&tabs=windows%2Csql-auth#configure-the-database"
      }}>{`step 1 of this Microsoft guide`}</a>{` to enable public access and allow our inbound IP addresses found at the bottom of this page.`}</p>
    <p>{`To link Azure SQL Server:`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New source`}</strong>{` and select Azure SQL Server`}</li>
      <li parentName="ol">{`Enter your database connection details:`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Host:`}</strong>{` The hostname or IP your database server like `}<inlineCode parentName="li">{`db.example.com`}</inlineCode>{` or `}<inlineCode parentName="li">{`123.132.1.100`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`Port:`}</strong>{` The port your database server is listening to. The default is `}<inlineCode parentName="li">{`1433`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`Database:`}</strong>{` The name of the database you want like `}<inlineCode parentName="li">{`analytics_db`}</inlineCode>{`.`}</li>
          <li parentName="ul"><strong parentName="li">{`User:`}</strong>{` The username with the necessary permissions to access the database.`}</li>
          <li parentName="ul"><strong parentName="li">{`Password:`}</strong>{` The password for the user.`}</li>
          <li parentName="ul"><strong parentName="li">{`Schema:`}</strong>{` The schema for your database where your tables are located. The default is `}<inlineCode parentName="li">{`dbo`}</inlineCode>{`.`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Link`}</strong></li>
    </ol>
    <p>{`The data warehouse then starts syncing your Azure SQL Server data. You can see details and progress in the `}<a parentName="p" {...{
        "href": "https://us.posthog.com/pipeline/sources"
      }}>{`sources tab`}</a>{`.`}</p>

    <InboundIpAddresses mdxType="InboundIpAddresses" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      